import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  //public
  public currentUser: Observable<any> = new Observable();

  //private
  public currentUserSubject: BehaviorSubject<any> | any;
  constructor(
    private http_client: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.currentUserSubject = new BehaviorSubject(
        JSON.parse(
          localStorage.getItem('currentUser')
            ? localStorage.getItem('currentUser') || '{}'
            : sessionStorage.getItem('currentUser') || '{}'
        )
      );
      this.currentUser = this.currentUserSubject.asObservable();
    }
  }

  login(email: string, password: string) {
    const URL = `${environment.BASE_URL}admins/login`;
    return this.http_client.post(URL, { email, password });
  }

  // getter: currentUserValue
  public get currentUserValue(): any {
    if (this.currentUserSubject) {
      return this.currentUserSubject.value;
    }
  }
}
